import { err, type Result } from 'neverthrow';
import type { Graph } from '../../../types/graph';
import type { CommandError, CommandResult, GraphCommand } from '../types';

export class FailCommand implements GraphCommand {
  readonly kind = 'fail';

  constructor(public readonly error: CommandError) {}

  apply(_graph: Readonly<Graph>): Result<CommandResult, CommandError> {
    return err(this.error);
  }
}
